import _t from 'i18n!nls/product-card';

export type MarketingStatusTag = {
  tag: string;
  tagName: string;
};

type MarketingTagCategory = 'job-ready' | 'job-skills' | 'bestseller' | 'top-ai-program';

// Single master slug -> category map
const MARKETING_TAG_SLUG_MAP: Record<string, MarketingTagCategory> = {
  'aapc-medical-biller': 'job-ready',
  'adobe-content-creator': 'job-skills',
  'adobe-marketing-specialist': 'job-skills',
  'adp-payroll-specialist': 'bestseller',
  'ai-agents': 'top-ai-program',
  'ai-agents-for-leaders': 'top-ai-program',
  'ai-agents-python': 'top-ai-program',
  'ai-engineer': 'top-ai-program',
  'ai-essentials-google': 'top-ai-program',
  'ai-for-business-wharton': 'top-ai-program',
  'ai-for-everyone': 'top-ai-program',
  'ai-foundations-business-professionals': 'top-ai-program',
  'ai-foundations-for-everyone': 'top-ai-program',
  'ai-governance-iso42001-readiness-grc-audit-legal': 'top-ai-program',
  'ai-healthcare': 'top-ai-program',
  'ai-infrastructure-operations-fundamentals': 'top-ai-program',
  'ai-mastery': 'top-ai-program',
  'ai-product-management-duke': 'top-ai-program',
  'amazon-junior-software-developer': 'job-skills',
  'applied-artifical-intelligence-ibm-watson-ai': 'top-ai-program',
  'aws-generative-ai-developers': 'top-ai-program',
  'ba-liberal-studies-georgetown': 'job-ready',
  'bach-information-technology-illinois-tech': 'job-ready',
  'bachelor-of-science-computer-science-bits': 'job-ready',
  'bachelor-of-science-computer-science-london': 'job-ready',
  'bachelor-of-science-data-science-ai-iitguwahati': 'job-ready',
  'bachelor-of-science-general-business-unt': 'job-ready',
  'bachelor-of-science-psychology-jgu': 'job-ready',
  brand: 'bestseller',
  'bsc-business-administration-london': 'job-ready',
  'bsc-data-science-huddersfield': 'job-ready',
  'bsc-marketing-london': 'job-ready',
  'building-ai-agents-and-agentic-workflows': 'top-ai-program',
  'chatgpt-free-ai-tools-to-excel': 'top-ai-program',
  'data-analytics': 'job-skills',
  'data-engineering': 'top-ai-program',
  'data-science-foundations': 'bestseller',
  'decentralized-finance-duke': 'bestseller',
  'deep-learning': 'top-ai-program',
  'ec-council-information-security-analyst': 'job-ready',
  'emba-iitr': 'job-ready',
  'facebook-social-media-marketing': 'job-skills',
  'fast-prototyping-of-genai-apps-with-streamlit': 'job-skills',
  'foundations-data': 'bestseller',
  'fundamentals-of-machine-learning-and-artificial-intelligence': 'top-ai-program',
  'generative-ai-for-digital-marketing': 'top-ai-program',
  'generative-ai-for-everyone': 'top-ai-program',
  'generative-ai-for-growth-marketing': 'top-ai-program',
  'generative-ai-for-human-resources': 'top-ai-program',
  'generative-ai-for-leaders': 'top-ai-program',
  'generative-ai-for-project-managers': 'top-ai-program',
  'generative-ai-for-software-developers': 'top-ai-program',
  'generative-ai-for-software-development': 'top-ai-program',
  'generative-ai-software-engineering': 'top-ai-program',
  'generative-ai-strategic-leader': 'top-ai-program',
  'generative-ai-with-llms': 'top-ai-program',
  'google-agile-essentials': 'bestseller',
  'google-ai': 'top-ai-program',
  'google-cloud-data-analytics-certificate': 'job-skills',
  'google-cybersecurity': 'job-skills',
  'google-data-analytics': 'job-skills',
  'google-digital-marketing-ecommerce': 'job-skills',
  'google-it-automation': 'bestseller',
  'google-it-support': 'job-skills',
  'google-people-management-essentials': 'bestseller',
  'google-project-management': 'job-skills',
  'google-ux-design': 'job-skills',
  'hrci-human-resource-associate': 'job-ready',
  'ibm-ai-product-manager': 'top-ai-program',
  'ibm-business-analyst-professional-certificate': 'job-ready',
  'ibm-cybersecurity-analyst': 'job-skills',
  'ibm-data-analyst': 'job-skills',
  'ibm-data-analyst-r-excel': 'bestseller',
  'ibm-data-engineer': 'job-skills',
  'ibm-digital-marketing-and-growth-hacking': 'job-skills',
  'ibm-full-stack-cloud-developer': 'job-skills',
  'ibm-generative-ai-engineering': 'top-ai-program',
  'ibm-isc2-cybersecurity-specialist': 'bestseller',
  'ibm-machine-learning': 'top-ai-program',
  'ibm-product-manager': 'job-ready',
  'ibm-product-owner': 'job-skills',
  'ibm-program-manager': 'job-skills',
  'ibm-project-manager': 'bestseller',
  'ibm-rag-and-agentic-ai': 'top-ai-program',
  'ifp-computer-science-london': 'job-ready',
  imba: 'job-ready',
  imsa: 'job-ready',
  'indigenous-canada': 'bestseller',
  'introduction-data-science': 'top-ai-program',
  'introduction-to-generative-ai': 'top-ai-program',
  'intuit-bookkeeping': 'job-ready',
  'jhu-data-science': 'bestseller',
  'johns-hopkins-medical-office-manager': 'job-ready',
  'learn-korean': 'bestseller',
  'ma-international-relations-security-strategy-jgu': 'job-ready',
  'ma-public-policy-jgu': 'job-ready',
  'machine-learning': 'top-ai-program',
  'machine-learning-introduction': 'top-ai-program',
  'machine-learning-scikit-learn-pytorch-hugging-face': 'top-ai-program',
  'mas-data-science-illinois-tech': 'job-ready',
  'mas-engineering-berkeley': 'job-ready',
  'mas-information-technology-illinois-tech': 'job-ready',
  'master-computer-science-clemson': 'job-ready',
  'master-of-data-science-university-of-pittsburgh': 'job-ready',
  'master-of-science-data-science-boulder': 'job-ready',
  'mastering-claude-ai-prompting-apis-rag-and-mcp': 'top-ai-program',
  'masters-in-computer-data-science': 'job-ready',
  'mathematics-for-machine-learning-and-data-science': 'top-ai-program',
  'mathematics-machine-learning': 'top-ai-program',
  'mba-business-analytics-jgu': 'job-ready',
  'mba-illinois-tech': 'job-ready',
  'me-engineering-management-boulder': 'job-ready',
  'meng-computer-engineering-dartmouth': 'job-ready',
  'meta-back-end-developer': 'job-ready',
  'meta-data-analyst': 'job-skills',
  'meta-front-end-developer': 'job-ready',
  'meta-full-stack-developer': 'job-ready',
  'microsoft-365-copilot': 'top-ai-program',
  'microsoft-365-copilot-for-productivity': 'top-ai-program',
  'microsoft-ai-and-ml-engineering': 'top-ai-program',
  'microsoft-ai-product-manager': 'top-ai-program',
  'microsoft-cloud-support-associate': 'job-skills',
  'microsoft-copilot-your-everyday-ai-companion': 'top-ai-program',
  'microsoft-cybersecurity-analyst': 'job-skills',
  'microsoft-data-analysis-sql-excel-powerbi': 'top-ai-program',
  'microsoft-data-visualization': 'bestseller',
  'microsoft-full-stack-developer': 'job-ready',
  'microsoft-power-bi-data-analyst': 'job-skills',
  'microsoft-project-management': 'job-skills',
  'microsoft-public-relations': 'job-skills',
  'microsoft-sql-server': 'job-ready',
  'mlops-machine-learning-duke': 'top-ai-program',
  'ms-artificial-intelligence-boulder': 'job-ready',
  'ms-computer-science-ball-state': 'job-ready',
  'ms-computer-science-boulder': 'job-ready',
  'ms-data-analytics-engineering-northeastern': 'job-ready',
  'ms-data-science-ball-state': 'job-ready',
  'ms-engineering-management-northeastern': 'job-ready',
  'ms-management-illinois': 'job-ready',
  'msc-computer-science-heriot-watt': 'job-ready',
  'msc-cyber-security-london': 'job-ready',
  'msc-data-science-ul': 'job-ready',
  'msc-management-huddersfield': 'job-ready',
  'msee-boulder': 'job-ready',
  'nasm-personal-fitness-trainer': 'job-ready',
  'natural-language-processing': 'top-ai-program',
  omie: 'job-ready',
  'prompt-engineering': 'top-ai-program',
  'prompting-essentials-google': 'top-ai-program',
  'python-3-programming': 'bestseller',
  'pytorch-for-deep-learning': 'top-ai-program',
  'real-world-ai-for-everyone': 'top-ai-program',
  'retrieval-augmented-generation-rag': 'bestseller',
  'sales-development-representative': 'bestseller',
  'salesforce-sales-operations': 'bestseller',
  'software-engineering-fundamentals': 'bestseller',
  'technical-support-fundamentals': 'bestseller',
  'unt-online-bachelor-completion': 'job-ready',
  'vibe-coding': 'top-ai-program',
  'wharton-success': 'bestseller',
  'ai-machinelearning-essentials': 'job-skills',
  'aws-cloud-technical-essentials': 'job-skills',
  'aws-generative-ai-applications': 'job-skills',
  'design-develop-and-deploy-multi-agent-systems-with-crewai': 'job-skills',
  'ai-prompting-for-everyone': 'job-skills',
  'gemini-for-developers': 'job-skills',
};

// MERCH-3315: the "Top AI program" pill color-treatment test now shares this master slug map's
// 'top-ai-program' category rather than qualifying its own separate set of slugs — it only tests
// UI treatment. Slugs in the map's other categories (job-ready/job-skills/bestseller) don't apply.
export const isTopAiProgramCategorySlug = (slug: string): boolean => MARKETING_TAG_SLUG_MAP[slug] === 'top-ai-program';

// tagName is kept as the pre-existing, stable analytics identifier for each category — it does
// not follow display-text casing changes, so tracking stays continuous with historical data.
const getMarketingTagContent = (category?: MarketingTagCategory): MarketingStatusTag | undefined => {
  switch (category) {
    case 'job-ready':
      return { tag: _t('Job ready'), tagName: 'Job Ready' };
    case 'job-skills':
      return { tag: _t('Job skills'), tagName: 'Job Skills' };
    case 'bestseller':
      return { tag: _t('Bestseller'), tagName: 'Bestseller' };
    case 'top-ai-program':
      return { tag: _t('Top AI program'), tagName: 'Top AI Program' };
    default:
      return undefined;
  }
};

export const getMarketingStatusTagForSlug = (slug: string): MarketingStatusTag | undefined => {
  const category = MARKETING_TAG_SLUG_MAP[slug];
  return getMarketingTagContent(category);
};
